/* global axios */
import ApiClient from './ApiClient';

class InboxConnectionAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  status(inboxId) {
    return axios.get(`${this.url}/${inboxId}/connection`);
  }

  refreshQr(inboxId) {
    return axios.post(`${this.url}/${inboxId}/connection/refresh_qr`);
  }

  disconnect(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/connection`);
  }
}

export default new InboxConnectionAPI();
